import { getGroupAccountMapStorage, getGroupStorage } from '../../../../backend/features/groups';
import { authGroup } from '../../../../backend/features/groups/entities/Group/Callbacks/OnAuth';
import { groupAccountMapEntityName } from '../../../../backend/features/groups/shared';
import { getAccountsViewFilterNew } from '../../../../backend/features/permissions/shared';
import { forEachEntityRow } from '../../../../backend/utils';
import { toKebabCase } from '../../../../utils';
import { defineBulkAction } from '@juvare/platform-sdk-react/backend/features/bulk-actions';
import { addAccountsToGroupBulkActionType } from '../shared';
import { getAccountStorage } from '../utils/getAccountStorage';
export const addAccountsToGroup = defineBulkAction({
    type: addAccountsToGroupBulkActionType,
    onAuthBulkAction: (userContext, { data }) => {
        authGroup(userContext.userState, getGroupStorage(userContext).get(data.params.groupId));
        return {
            secureFilter: [...getAccountsViewFilterNew(userContext.userState), ...data.params.filter],
        };
    },
    onProcessBulkAction: (appContext, { data, isCancelled, updateTotalCount, updateProcessedCount }) => {
        const groupAccountMapStorage = getGroupAccountMapStorage(appContext);
        const accountStorage = getAccountStorage(appContext);
        forEachEntityRow(accountStorage, { filter: data.secureParams.secureFilter, orderBy: [{ column: 'email' }] }, (row, idx) => {
            groupAccountMapStorage.post({
                action: 'create-or-update',
                data: {
                    groupId: data.params.groupId,
                    accountId: row.id,
                },
                uniqueColumn: 'unique',
                auditTags: [toKebabCase(groupAccountMapEntityName).replace(/-+/g, '-')],
                actionParams: {
                    bulkAction: true,
                },
            });
            appContext.invalidateUserStateForUserId(row.id);
            updateProcessedCount(idx + 1);
            return { cancel: isCancelled() };
        }, updateTotalCount);
    },
});
